<template>
  <bim-container>
    <bim-row style="overflow: hidden;" justify="center">
      <bim-col cols="12" lg="10" xxl="8">
        <Links-Swiper />
      </bim-col>
    </bim-row>
    <bim-row justify="center">
      <bim-col class="main-content--overflow" cols="12" md="8" lg="7" xxl="6">
        <Main-content v-bind="$props" :sliderData="sliderData" />
      </bim-col>
      <bim-col v-if="$windowWidth >= 767.9" cols="12" md="4" lg="3" xxl="2">
        <Sidebar v-bind="$props" :sliderData="sliderData" />
      </bim-col>
    </bim-row>
  </bim-container>
</template>

<script>
import bimContainer from '@bimlib/components/bimContainer'
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'

import LinksSwiper from '@/components/models/LinksSwiper'
import MainContent from '@/components/models/Content'
import Sidebar from '@/components/models/Sidebar'

export default {
  name: 'ModelsСard',
  components: {
    bimContainer,
    bimRow,
    bimCol,
    LinksSwiper,
    MainContent,
    Sidebar
  },
  props: {
    modelData: {
      type: Object,
      required: true
    },
    authorData: {
      type: Object,
      required: true
    },
    apicad: {
      type: Boolean,
    },
    qrCode: String,
    isUserAuth: Boolean,
    isIos: Boolean,
    isAndroidOs: Boolean,
  },
  created() {
    // this.loadRedHelper();
  },
  computed: {
    /**
     * Формирует массив картинок, 3d и видео для слайдера.
     * @return {array} - массив объектов с ссылками и типами слайдов. Так же у картинок присутствует поле position отвечающее за её положение (индекс). Требуется для открытия модалки изображений с кликнутого слайда.
     */
    sliderData () {
      const videoLink    = this.parseVideoLink(this.modelData.link_youtube),
            // model3dLink  = this.modelData.Viewer3D,
            images       = this.modelData.images_down,
            modelAr      = typeof this.modelData.files === "undefined" ? [] : this.modelData.files.filter(el => el.file_extension.trim().toLowerCase() === 'glb' ||  el.file_extension.trim().toLowerCase() === 'gltf'),
            videoObj     = videoLink ? { id: Math.floor(Math.random() * (999-1) + 1), src: videoLink, type: 'video' } : null,
            // model3dObj   = model3dLink ? { id: Math.floor(Math.random() * (99-1) + 1), src: images[0], type: 'model3d' } : null,
            imageObjects = images.length ? images.map((img, idx) => ({ id: Math.floor(Math.random() * (999-1) + 1), src: img, type: 'image', position: idx })) : [],
            modelArObjects   = modelAr.length ? modelAr.map(model => ({ id: Math.floor(Math.random() * (999-1) + 1), src: images[0], type: 'modelAr', link: model.path_f})) : []

      return [videoObj, ...modelArObjects, ...imageObjects].filter(el => el != null)
    },
  },
  methods: {
    /**
     * Парсит ссылки на видео (такая же функция находится в ЛК при создании/редактировании модели
     * p.s. данная функция вставлена только для поддержки старых моделей.
     * @param videolink - исходная ссылка, полученная из БД
     * @return {string} - преобразованная ссылка на youtube или vimeo
     */
    parseVideoLink (videolink) {
      let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
      let match = videolink.match(regExp)

      if (match && match[7].length === 11) {
        return `https://www.youtube.com/embed/${match[7]}`
      }

      regExp = 'vimeo\\.com/(?:.*#|.*/videos/)?([0-9]+)'
      match = videolink.match(regExp)

      if (match) {
        const videoId = videolink.split('/')[videolink.split('/').length - 1]
        return `https://player.vimeo.com/video/${videoId}`
      } else if (videolink.includes('vimeo')) return videolink
    },
  }
}
</script>

